import { Banner } from "../../Banner";
import { Drawer, type DrawerProps } from "../../Drawer";
import { LoadingState } from "../../LoadingState";
import {
  SelectPopoverContextProvider,
  SelectPopoverContent,
  type SelectPopoverType,
} from "../../SelectPopover";
import classNames from "classnames/bind";
import React from "react";
import styles from "./DataTableColumnConfigurationDrawer.module.scss";

const cx = classNames.bind(styles);

export const DataTableColumnConfigurationDrawer = ({
  title = "Columns",
  isLoading = false,
  inputProps,
  ...restProps
}: Omit<DrawerProps, "children"> & {
  inputProps: SelectPopoverType;
  isLoading: boolean;
}) => {
  return (
    <SelectPopoverContextProvider {...inputProps}>
      <Drawer
        title={title}
        size="md"
        {...restProps}
      >
        <LoadingState
          isLoading={isLoading}
          label="Loading configuration"
        >
          <Banner
            className={cx("auto-save-banner")}
            titleText="Changes save automatically"
            description={
              <>
                Column selections you make here are saved to this browser as
                your personal UI configuration.
                <br />
                You can also save these selections to be the company default.
              </>
            }
            variant="info"
          />
          <SelectPopoverContent className={cx("config-list")} />
        </LoadingState>
      </Drawer>
    </SelectPopoverContextProvider>
  );
};
